import React from 'react';
import Ratings from '../Rating/Ratings';
import './Review.css';

const Review = ({review}) => {
    const { name, img, ratting, comment } = review;
    return (
      <div className='review'>
        <div>
          <img className="review-img h-[375px] w-full p-4" src={img} alt="" />
        </div>
        <div className='m-5'>
          <h1 className='text-2xl text-center font-bold'>{name}</h1>
          <p className='text-xl my-3'>{comment}</p>
          <p>{<Ratings rating={ ratting}/>}</p>
        </div>
      </div>
    );
};

export default Review;